import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  acceptAiDataModel,
  acceptAiDataModelFailure,
  acceptAiDataModelSuccess,
  generateModelForFieldPrompt,
  generateModelForFieldPromptFailure,
  generateModelForFieldPromptSuccess,
  generateModelForTablePrompt,
  generateModelForTablePromptFailure,
  generateModelForTablePromptSuccess,
  rejectAiDataModel,
  rejectAiDataModelFailure,
  rejectAiDataModelSuccess,
  updateAIDM,
  updateAIDMFail,
  updateAIDMSuccess
} from '../actions/aiapplicationdatamodel.actions';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { Store } from '@ngrx/store';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class AiAppDataModelEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  acceptAiDataModel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(acceptAiDataModel),
        map((action) => {
          this.store.dispatch(acceptAiDataModelSuccess({ acceptSuccessData: null }));
          this.store.dispatch(acceptAiDataModelFailure({ acceptFailureData: null }));

          this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (results: any) => {
              this.store.dispatch(acceptAiDataModelSuccess({ acceptSuccessData: results }));
            },
            (err: any) => {
              this.store.dispatch(acceptAiDataModelFailure({ acceptFailureData: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  rejectAiDataModel$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(rejectAiDataModel),
        map((action) => {
          this.store.dispatch(rejectAiDataModelSuccess({ rejectSuccessData: null }));
          this.store.dispatch(rejectAiDataModelFailure({ rejectFailureData: null }));

          this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (results: any) => {
              this.store.dispatch(rejectAiDataModelSuccess({ rejectSuccessData: results }));
            },
            (err: any) => {
              this.store.dispatch(rejectAiDataModelFailure({ rejectFailureData: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  updateAIDM$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateAIDM),
        map((action) => {
          this.store.dispatch(updateAIDMSuccess({ aiDMSuccData: null }));
          this.store.dispatch(updateAIDMFail({ aiDMFailData: null }));
          this.baseService[action.updApiConstants.method](action.updApiConstants, action.aiDMData).subscribe(
            (results: any) => {
              this.store.dispatch(updateAIDMSuccess({ aiDMSuccData: results }));
            },
            (err: any) => {
              this.store.dispatch(updateAIDMFail({ aiDMFailData: { err: err, aiDMData: action.aiDMData } }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  generateModelForTablePrompt$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(generateModelForTablePrompt),
        map((action) => {
          this.store.dispatch(generateModelForTablePromptSuccess({ generateModelForTablePromptSuccData: null }));
          this.store.dispatch(generateModelForTablePromptFailure({ generateModelForTablePromptFailData: null }));
          this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (results: any) => {
              this.store.dispatch(generateModelForTablePromptSuccess({ generateModelForTablePromptSuccData: results }));
            },
            (err: any) => {
              this.store.dispatch(generateModelForTablePromptFailure({ generateModelForTablePromptFailData: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  generateModelForFieldPrompt$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(generateModelForFieldPrompt),
        map((action) => {
          this.store.dispatch(generateModelForFieldPromptSuccess({ generateModelForFieldPromptSuccData: null }));
          this.store.dispatch(generateModelForFieldPromptFailure({ generateModelForFieldPromptFailData: null }));
          this.baseService[action.apiConstants.method](action.apiConstants, action.params).subscribe(
            (results: any) => {
              this.store.dispatch(generateModelForFieldPromptSuccess({ generateModelForFieldPromptSuccData: results }));
            },
            (err: any) => {
              this.store.dispatch(generateModelForFieldPromptFailure({ generateModelForFieldPromptFailData: err }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
}
